import { render } from "./WealthReviewDashboard.vue?vue&type=template&id=27917252&scoped=true"
import script from "./WealthReviewDashboard.vue?vue&type=script&lang=js"
export * from "./WealthReviewDashboard.vue?vue&type=script&lang=js"

import "./WealthReviewDashboard.vue?vue&type=style&index=0&id=27917252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27917252"]])

export default __exports__